const i18nStore = {
  "zh-Hant": {
    "translation": {}
  },
  "zh-CN": {
    "translation": {
      "DUET_H5_ACCOUNT_MANAGE_CODE_ERROR_TOAST": "验证码错误，请检查后重试",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_BACK_BUTTON": "退出",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_DELETE_ACCOUNT_BUTTON": "删除账号",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_POPUP_BACK_BUTTON": "返回",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_POPUP_CONFIRM_BUTTON": "删除",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_POPUP_SUBTITLE": "删除之后，你的所有资料、配对好友、聊天记录等数据将无法恢复",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_POPUP_TITLE": "请确认：是否彻底删除你的账号",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_TITLE": "管理我的账户",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_SUCCESS_TOAST": "你的Duet账户已被成功删除",
      "DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_BUTTON": "退出",
      "DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_SUBTITLE": "无法找到相关账户信息，请检查你使用的登录方式后再重试",
      "DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_TITLE": "哎呀，发生错误了",
      "DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_GOOGLE_LOGIN": "使用Google登录",
      "DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_PHONE_LOGIN": "使用手机号码登录",
      "DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_SUBTITLE": "请登录以继续",
      "DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_TITLE": "管理我的账户",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_ERROR_TOAST": "手机号码格式错误，请检查后重试",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_BACK_BUTTON": "返回",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_COUNTDOWN_BUTTON": "重新发送",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_NEXT_BUTTON": "提交",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_PLACEHOLDER": "请输入验证码",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_RETRY_BUTTON": "重新发送",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_SUBTITLE": "我们给你的号码<span>{{number}}</span>发送了一则验证码，收到后请在下方输入",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_TITLE": "请输入验证码",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_BACK_BUTTON": "返回",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_NEXT_BUTTON": "下一步",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_PLACEHOLDER": "请输入手机号码",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_SUBTITLE": "请输入你Duet账号绑定的手机号",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_TITLE": "使用手机号码登录",
      "DUET_H5_ACCOUNT_MANAGE_REQUEST_MAX_ERROR_TOAST": "你今天的验证请求太多啦，请明天再试吧",
      "DUET_QUESTIONNAIRE_ASKING_NO": "残忍离开",
      "DUET_QUESTIONNAIRE_ASKING_SUBTITLE": "希望您可以提供一些意见，只需一分钟完成简单问卷",
      "DUET_QUESTIONNAIRE_ASKING_TITLE": "抱歉Duet未能令您满意...",
      "DUET_QUESTIONNAIRE_ASKING_YES": "确定",
      "DUET_QUESTIONNAIRE_Q1": "请问您经常使用交友软件吗？",
      "DUET_QUESTIONNAIRE_Q1_A1": "经常使用，已经是资深用户了",
      "DUET_QUESTIONNAIRE_Q1_A2": "还可以，有空就会玩一玩",
      "DUET_QUESTIONNAIRE_Q1_A3": "不怎么使用，就是尝试一下",
      "DUET_QUESTIONNAIRE_Q2": "您有使用其他交友软件吗？",
      "DUET_QUESTIONNAIRE_Q2_A1": "Tinder",
      "DUET_QUESTIONNAIRE_Q2_A2": "Bumble",
      "DUET_QUESTIONNAIRE_Q2_A3": "Hinge",
      "DUET_QUESTIONNAIRE_Q2_A4": "CMB",
      "DUET_QUESTIONNAIRE_Q2_A5": "Badoo",
      "DUET_QUESTIONNAIRE_Q2_ENTER": "其他（请输入）",
      "DUET_QUESTIONNAIRE_Q3": "在使用时最看重的因素是？",
      "DUET_QUESTIONNAIRE_Q3_A1": "玩法丰富",
      "DUET_QUESTIONNAIRE_Q3_A2": "用户量大",
      "DUET_QUESTIONNAIRE_Q3_A3": "安全隐私",
      "DUET_QUESTIONNAIRE_Q3_A4": "性价比高",
      "DUET_QUESTIONNAIRE_Q3_A5": "用户质量高",
      "DUET_QUESTIONNAIRE_Q3_A6": "简单易用",
      "DUET_QUESTIONNAIRE_Q3_ENTER": "其他（请输入）",
      "DUET_QUESTIONNAIRE_Q4": "我们看见您是因为选择离开，请问方便告诉我们具体情况吗？",
      "DUET_QUESTIONNAIRE_Q4_CONTINUE_BUTTON": "确定",
      "DUET_QUESTIONNAIRE_Q4_ENTER": "请输入",
      "DUET_QUESTIONNAIRE_Q4_ERROR_TOAST": "请输入至少10个字符",
      "DUET_SWIPRE_PROFILE_PREVIEW_ABTME": "关于我",
      "DUET_SWIPRE_PROFILE_PREVIEW_BASICS": "基本信息",
      "DUET_SWIPRE_PROFILE_PREVIEW_MOREABTME": "更多",
      "DUET_SWIPRE_PROFILE_PREVIEW_MOREABTME_SEEALL": "查看所有",
      "DUET_SWIPRE_PROFILE_PREVIEW_VERIFED_ICON": "已认证",
      "DUET_SWIPRE_PROFILE_PREVIEW_VERIFY_SUBTITLE": "通过面部比对，其个人照片已通过真人认证",
      "DUET_SWIPRE_PROFILE_PREVIEW_VERIFY_TITLE": "%@的照片已通过认证",
      "DUET_WEB_SIGNIN_ENTRANCE": "登录",
      "DUET_WEB_SIGNIN_NUMBER_BUTTON": "下一步",
      "DUET_WEB_SIGNIN_NUMBER_CONTENT": "我们将给你的号码发送一个验证码。不用担心，你的号码不会被泄漏，且不会出现在你的个人资料上。",
      "DUET_WEB_SIGNIN_NUMBER_COUNTRYCODE": "国家",
      "DUET_WEB_SIGNIN_NUMBER_MOBILE": "手机号码",
      "DUET_WEB_SIGNIN_NUMBER_TITLE": "请输入你的注册手机号",
      "DUET_WEB_SIGNIN_NUMBER_WRONG_TOAST": "请确认填写正确的手机号码！",
      "DUET_WEB_SIGNIN_OTP_CHANGENUMBER": "更换联系方式",
      "DUET_WEB_SIGNIN_OTP_COUNTDOWN": "%@ 秒",
      "DUET_WEB_SIGNIN_OTP_RESEND": "重新发送",
      "DUET_WEB_SIGNIN_OTP_TITLE": "输入验证码",
      "DUET_WEB_SIGNIN_OTP_WRONG": "请确认输入正确的的验证码",
      "DUET_WEB_SIGNIN_START_BUTTON": "手机号登录",
      "DUET_WEB_SIGNIN_START_CONTENT": "输入注册手机号码登录Duet网页版",
      "DUET_WEB_SIGNIN_START_TITLE": "开始体验",
      "DUET_WEB_SWIPE_DISLIKE": "不喜欢",
      "DUET_WEB_SWIPE_LIKE": "喜欢",
      "DUET_WEB_SWIPE_NOUSER": "附近没有用户啦...",
      "DUET_WEB_SWIPE_PROFILE_DOWN": "向下滑动资料",
      "DUET_WEB_SWIPE_PROFILE_UP": "向上滑动资料",
      "DUET_WEB_SWIPE_SIGNOUT_BUTTON": "登出",
      "DUET_WEB_SWIPE_STOP_BUTTON": "好的",
      "DUET_WEB_SWIPE_STOP_CONTENT": "我们已记住你的滑卡偏好啦～",
      "DUET_WEB_SWIPE_STOP_TITLE": "滑卡偏好已记录",
      "OMI_DATA_DOWNLOAD_ACCOUNT_FOUND_DESC": "我们找到了您已删除的账号。",
      "OMI_DATA_DOWNLOAD_ACCOUNT_FOUND_TITLE": "找到账号",
      "OMI_DATA_DOWNLOAD_ACCOUNT_INFO": "您的账号 {contact} 已于 {date} 删除。您可以在 {date} 前下载数据。",
      "OMI_DATA_DOWNLOAD_ACCOUNT_NOT_FOUND": "未找到与此邮箱/登录方式关联的账号。",
      "OMI_DATA_DOWNLOAD_APP_MSG_BODY": "您的数据下载请求已处理完成。为确保安全，请登录账号管理页面 {url} 下载。",
      "OMI_DATA_DOWNLOAD_APP_MSG_TITLE": "您的数据已准备好",
      "OMI_DATA_DOWNLOAD_CANCEL_BTN": "取消",
      "OMI_DATA_DOWNLOAD_CANCEL_CONFIRM_BTN": "我知道了，取消",
      "OMI_DATA_DOWNLOAD_CANCEL_DESC": "如果文件已就绪，取消将立即删除该文件。已就绪的文件在 7 天后过期。",
      "OMI_DATA_DOWNLOAD_CANCEL_KEEP_BTN": "保留请求",
      "OMI_DATA_DOWNLOAD_CANCEL_POINT_1": "取消后，此请求将从列表中移除。",
      "OMI_DATA_DOWNLOAD_CANCEL_POINT_2": "您随时可以提交新的请求。",
      "OMI_DATA_DOWNLOAD_CANCEL_TITLE": "取消此请求？",
      "OMI_DATA_DOWNLOAD_CODE_INCORRECT": "验证码错误或已过期，请重试。",
      "OMI_DATA_DOWNLOAD_CONTINUE_APPLE": "使用 Apple 继续",
      "OMI_DATA_DOWNLOAD_CONTINUE_FACEBOOK": "使用 Facebook 继续",
      "OMI_DATA_DOWNLOAD_CONTINUE_GOOGLE": "使用 Google 继续",
      "OMI_DATA_DOWNLOAD_DATA_AVAILABLE_UNTIL": "数据可下载至：",
      "OMI_DATA_DOWNLOAD_DATA_EXPIRED": "您的账号数据已超过保留期限，无法下载。",
      "OMI_DATA_DOWNLOAD_DELETED_ON": "账号删除时间：",
      "OMI_DATA_DOWNLOAD_DONE_BTN": "完成",
      "OMI_DATA_DOWNLOAD_DOWNLOAD_BTN": "下载",
      "OMI_DATA_DOWNLOAD_DOWNLOAD_TITLE": "下载您的数据",
      "OMI_DATA_DOWNLOAD_DOWNLOAD_VERIFY_EMAIL": "为确保安全，请输入您的邮箱地址以验证身份后下载。",
      "OMI_DATA_DOWNLOAD_DOWNLOAD_VERIFY_PHONE": "为确保安全，请输入您手机号的后 4 位以验证身份后下载。",
      "OMI_DATA_DOWNLOAD_EMAIL_BODY": "您的数据下载请求已处理完成。请登录账号管理页面下载数据：{link}。下载有效期为 7 天（至 {date}）。",
      "OMI_DATA_DOWNLOAD_EMAIL_DATA_READY_BODY": "您的数据已准备好下载。点击以下链接下载：{link}。为确保安全，下载前需验证您的邮箱地址。链接 24 小时内有效。",
      "OMI_DATA_DOWNLOAD_EMAIL_DATA_READY_SUBJECT": "[{app_name}] 您的数据已准备好下载",
      "OMI_DATA_DOWNLOAD_EMAIL_INCORRECT": "输入的邮箱地址不匹配，请重试。",
      "OMI_DATA_DOWNLOAD_EMAIL_INPUT_HINT": "输入您的邮箱地址以接收验证码。",
      "OMI_DATA_DOWNLOAD_EMAIL_SUBJECT": "[{app_name}] 您的数据已准备好下载",
      "OMI_DATA_DOWNLOAD_EMAIL_VERIFICATION_BODY": "您的验证码是：{code}。验证码 10 分钟内有效。如果您没有请求此验证码，请忽略此邮件。",
      "OMI_DATA_DOWNLOAD_EMAIL_VERIFICATION_SUBJECT": "[{app_name}] 您的验证码",
      "OMI_DATA_DOWNLOAD_HISTORY_DESC": "每条记录包含请求时间前 12 个月的数据。已就绪的文件有效期为 7 天。",
      "OMI_DATA_DOWNLOAD_HISTORY_TITLE": "您的下载请求",
      "OMI_DATA_DOWNLOAD_LINK_EXPIRED_DESC": "此下载链接已过期或不再有效。",
      "OMI_DATA_DOWNLOAD_LINK_EXPIRED_TITLE": "链接已过期",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_APP": "数据准备好后，我们将通过 {app_name} Team App 内消息通知您。",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_EMAIL": "数据准备好后，我们将通过邮件通知 {email}。",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_EMAIL_DESC": "数据准备好后，我们将通过邮件通知 {email}。",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_SMS": "数据准备好后，我们将通过短信通知 {phone}。",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_SMS_DESC": "数据准备好后，我们将通过短信通知 {phone}。",
      "OMI_DATA_DOWNLOAD_PAGE_SUBTITLE": "请求与历史",
      "OMI_DATA_DOWNLOAD_PAGE_TITLE": "下载我的信息",
      "OMI_DATA_DOWNLOAD_PHONE_DIGITS_INCORRECT": "输入的数字不匹配，请重试。",
      "OMI_DATA_DOWNLOAD_PHONE_INPUT_HINT": "输入您的手机号以接收验证码。",
      "OMI_DATA_DOWNLOAD_REQUEST_NEW_DOWNLOAD": "重新请求下载",
      "OMI_DATA_DOWNLOAD_REQUEST_SUBMITTED": "请求已提交",
      "OMI_DATA_DOWNLOAD_REQUEST_SUBMITTED_DESC": "我们将在 24 小时内准备好您过去 12 个月的数据 ZIP 包。",
      "OMI_DATA_DOWNLOAD_RESEND_CODE": "重新发送验证码",
      "OMI_DATA_DOWNLOAD_RETRIEVE_ACTION_DESC": "如需获取数据副本，请提交下载请求。",
      "OMI_DATA_DOWNLOAD_RETRIEVE_DESC": "如果您的账号仍处于活跃状态或在过去 3 个月内被删除，您可以下载您的个人数据副本。",
      "OMI_DATA_DOWNLOAD_RETRIEVE_SUBTITLE": "验证身份以继续",
      "OMI_DATA_DOWNLOAD_RETRIEVE_TITLE": "下载我的信息",
      "OMI_DATA_DOWNLOAD_SEND_CODE_BTN": "发送验证码",
      "OMI_DATA_DOWNLOAD_SMS_DATA_READY": "您的数据已准备好。登录下载：{{link}}。有效期 7 天。",
      "OMI_DATA_DOWNLOAD_SMS_DATA_READY_1DAY": "您的数据已准备好。下载链接：{{link}}。链接 24 小时内有效。",
      "OMI_DATA_DOWNLOAD_SMS_VERIFICATION_CODE": "您的 {app_name} 验证码是：{code}。验证码 10 分钟内有效，请勿分享给他人。",
      "OMI_DATA_DOWNLOAD_STATUS_PREPARING": "准备中",
      "OMI_DATA_DOWNLOAD_STATUS_READY": "已就绪",
      "OMI_DATA_DOWNLOAD_SUBMIT_BTN": "提交下载请求",
      "OMI_DATA_DOWNLOAD_SUBMIT_DESC": "如需导出您的数据副本，请提交下载请求。我们将在 24 小时内准备好您过去 12 个月的数据 ZIP 包。",
      "OMI_DATA_DOWNLOAD_SUBMIT_REQUEST_BTN": "提交数据请求",
      "OMI_DATA_DOWNLOAD_SUBMIT_SECTION_TITLE": "提交下载请求",
      "OMI_DATA_DOWNLOAD_TEMP_PHONE_DESC": "由于您的账号未绑定手机号或邮箱，请提供一个手机号以接收下载通知。",
      "OMI_DATA_DOWNLOAD_TEMP_PHONE_NOTICE": "此号码仅用于本次下载请求，不会添加到您的账号。",
      "OMI_DATA_DOWNLOAD_TEMP_PHONE_TITLE": "提供通知联系方式",
      "OMI_DATA_DOWNLOAD_TOO_MANY_ATTEMPTS": "尝试次数过多，请1天后再试。",
      "OMI_DATA_DOWNLOAD_USE_DIFFERENT_EMAIL": "使用其他邮箱",
      "OMI_DATA_DOWNLOAD_USE_DIFFERENT_PHONE": "使用其他手机号",
      "OMI_DATA_DOWNLOAD_VALID_UNTIL": "有效期至：",
      "OMI_DATA_DOWNLOAD_VERIFY_BTN": "验证",
      "OMI_DATA_DOWNLOAD_VERIFY_EMAIL_DESC": "我们已向 {email} 发送了 6 位验证码。",
      "OMI_DATA_DOWNLOAD_VERIFY_PHONE_DESC": "输入发送至 {phone} 的 6 位验证码。",
      "OMI_DATA_DOWNLOAD_VERIFY_PHONE_TITLE": "验证手机号",
      "OMI_DATA_DOWNLOAD_VERIFY_WITH_EMAIL": "使用邮箱验证",
      "OMI_DATA_DOWNLOAD_VERIFY_WITH_PHONE": "使用手机号验证",
      "OMI_LANDINGPAGE_SIGNIN_APPLE_NEW": "使用Apple ID账号登入",
      "OMI_LOGIN_SUBSCRIPTION": "登入将视为您已同意我们的政策与条款。了解我们的Cookie政策与隐私政策。",
      "OMI_SETTING_COOKIE_POLICY": "Cookie政策"
    }
  },
  "en": {
    "translation": {
      "DUET_H5_ACCOUNT_MANAGE_CODE_ERROR_TOAST": "Verification code error, please check and try again",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_BACK_BUTTON": "Back",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_DELETE_ACCOUNT_BUTTON": "Delete Account",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_POPUP_BACK_BUTTON": "Back",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_POPUP_CONFIRM_BUTTON": "Delete",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_POPUP_SUBTITLE": "All your profile information, matches, and messages will be deleted",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_POPUP_TITLE": "Are you sure you want to delete your account?",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_PAGE_TITLE": "Manage My Account",
      "DUET_H5_ACCOUNT_MANAGE_DELETE_SUCCESS_TOAST": "Your Duet account is successfully deleted",
      "DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_BUTTON": "Back",
      "DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_SUBTITLE": "We cannot find this account. Please check your login method and try again.",
      "DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_TITLE": "Oops",
      "DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_GOOGLE_LOGIN": "Sign In With Google",
      "DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_PHONE_LOGIN": "Sign In With Phone Number",
      "DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_SUBTITLE": "Sign in to continue",
      "DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_TITLE": "Manage My Account",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_ERROR_TOAST": "Please make sure this phone number is valid",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_BACK_BUTTON": "Back",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_COUNTDOWN_BUTTON": "Resend",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_NEXT_BUTTON": "Submit",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_PLACEHOLDER": "Enter your code",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_RETRY_BUTTON": "Resend",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_SUBTITLE": "We've sent the code to <span>{{number}}</span>, please fill in the code",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_CODE_PAGE_TITLE": "Enter Your Code",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_BACK_BUTTON": "Back",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_NEXT_BUTTON": "Next",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_PLACEHOLDER": "Enter your number",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_SUBTITLE": "Please fill in the phone number connected with your Duet account",
      "DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_TITLE": "Sign In With Phone Number",
      "DUET_H5_ACCOUNT_MANAGE_REQUEST_MAX_ERROR_TOAST": "You have too many verification requests today. Please try again tomorrow.",
      "DUET_NEW_LOGIN_CODE": "Scan the QR code in the Duet app to log in",
      "DUET_NEW_LOGIN_CODE_SUBTITLE": "Open Duet → Me → Tap the \"Scan\" button at the top of the screen.",
      "DUET_NEW_LOGIN_CODE_TITLE": "Open the Duet app to scan and log in",
      "DUET_QR_CODE_GAGAL_TOAST": "Oops! The QR code has expired. Please refresh and scan again.",
      "DUET_QR_CODE_SUCCESS_TOAST": "You're logged in. Enjoy your time on Duet!",
      "DUET_QUESTIONNAIRE_ASKING_NO": "Quit",
      "DUET_QUESTIONNAIRE_ASKING_SUBTITLE": "Would you like to share your inspects on how we can improve your dating experience?",
      "DUET_QUESTIONNAIRE_ASKING_TITLE": "We're sad to see you go…",
      "DUET_QUESTIONNAIRE_ASKING_YES": "Sure",
      "DUET_QUESTIONNAIRE_Q1": "Do you often use dating apps?",
      "DUET_QUESTIONNAIRE_Q1_A1": "Very often. I know dating apps pretty well.",
      "DUET_QUESTIONNAIRE_Q1_A2": "Sometimes. I'll have a look when I'm free.",
      "DUET_QUESTIONNAIRE_Q1_A3": "Not so often. I just want to have a go.",
      "DUET_QUESTIONNAIRE_Q2": "Are you using other dating apps?",
      "DUET_QUESTIONNAIRE_Q2_A1": "Tinder",
      "DUET_QUESTIONNAIRE_Q2_A2": "Bumble",
      "DUET_QUESTIONNAIRE_Q2_A3": "Hinge",
      "DUET_QUESTIONNAIRE_Q2_A4": "CMB",
      "DUET_QUESTIONNAIRE_Q2_A5": "Badoo",
      "DUET_QUESTIONNAIRE_Q2_ENTER": "Other (Type your answer)",
      "DUET_QUESTIONNAIRE_Q3": "What's your premium concern when using a dating app?",
      "DUET_QUESTIONNAIRE_Q3_A1": "Have many fun features",
      "DUET_QUESTIONNAIRE_Q3_A2": "Have many active users",
      "DUET_QUESTIONNAIRE_Q3_A3": "Safe and lay emphasis on privacy",
      "DUET_QUESTIONNAIRE_Q3_A4": "Low costs for commercial features",
      "DUET_QUESTIONNAIRE_Q3_A5": "The quality of users is good",
      "DUET_QUESTIONNAIRE_Q3_A6": "Easy to use",
      "DUET_QUESTIONNAIRE_Q3_ENTER": "Other (Type your answer)",
      "DUET_QUESTIONNAIRE_Q4": "May we know why you want to leave?",
      "DUET_QUESTIONNAIRE_Q4_CONTINUE_BUTTON": "Continue",
      "DUET_QUESTIONNAIRE_Q4_ENTER": "Type",
      "DUET_QUESTIONNAIRE_Q4_ERROR_TOAST": "Please enter at least 10 letters.",
      "DUET_SWIPRE_PROFILE_PREVIEW_ABTME": "About me",
      "DUET_SWIPRE_PROFILE_PREVIEW_BASICS": "My basics",
      "DUET_SWIPRE_PROFILE_PREVIEW_MOREABTME": "More about me",
      "DUET_SWIPRE_PROFILE_PREVIEW_MOREABTME_SEEALL": "See all",
      "DUET_SWIPRE_PROFILE_PREVIEW_VERIFED_ICON": "Verified",
      "DUET_SWIPRE_PROFILE_PREVIEW_VERIFY_SUBTITLE": "This profile photo is verified through facial comparison.",
      "DUET_SWIPRE_PROFILE_PREVIEW_VERIFY_TITLE": "%@'s Photo is Verified",
      "DUET_WEB_SIGNIN_ENTRANCE": "Sign in",
      "DUET_WEB_SIGNIN_NUMBER_BUTTON": "Continue",
      "DUET_WEB_SIGNIN_NUMBER_CONTENT": "We'll need to send you a verification number to your phone. Don't worry, this info remains private and will never appear on your profile.",
      "DUET_WEB_SIGNIN_NUMBER_COUNTRYCODE": "Country",
      "DUET_WEB_SIGNIN_NUMBER_MOBILE": "Phone Number",
      "DUET_WEB_SIGNIN_NUMBER_TITLE": "Enter your phone number",
      "DUET_WEB_SIGNIN_NUMBER_WRONG_TOAST": "Please confirm your phone number is correct.",
      "DUET_WEB_SIGNIN_OTP_CHANGENUMBER": "Change phone number",
      "DUET_WEB_SIGNIN_OTP_COUNTDOWN": "%@s",
      "DUET_WEB_SIGNIN_OTP_RESEND": "Resend",
      "DUET_WEB_SIGNIN_OTP_TITLE": "Enter Your Verification Code",
      "DUET_WEB_SIGNIN_OTP_WRONG": "Please make sure you entered the right verification code.",
      "DUET_WEB_SIGNIN_START_BUTTON": "Log in with Phone Number",
      "DUET_WEB_SIGNIN_START_CONTENT": "Log in using your registered number to experience Duet on the web.",
      "DUET_WEB_SIGNIN_START_TITLE": "Start Now",
      "DUET_WEB_SWIPE_DISLIKE": "Dislike",
      "DUET_WEB_SWIPE_LIKE": "Like",
      "DUET_WEB_SWIPE_NOUSER": "There is no one new around you...",
      "DUET_WEB_SWIPE_PROFILE_DOWN": "Scroll down the profile",
      "DUET_WEB_SWIPE_PROFILE_UP": "Scroll up the profile",
      "DUET_WEB_SWIPE_SIGNOUT_BUTTON": "Sign out",
      "DUET_WEB_SWIPE_STOP_BUTTON": "OK",
      "DUET_WEB_SWIPE_STOP_CONTENT": "We've noted your swipe preferences!",
      "DUET_WEB_SWIPE_STOP_TITLE": "Swipe Preferences Noted",
      "OMI_DATA_DOWNLOAD_ACCOUNT_FOUND_DESC": "We found your deleted account.",
      "OMI_DATA_DOWNLOAD_ACCOUNT_FOUND_TITLE": "Account Found",
      "OMI_DATA_DOWNLOAD_ACCOUNT_INFO": "Your account {contact} was deleted on {date}. You can download your data until {date}.",
      "OMI_DATA_DOWNLOAD_ACCOUNT_NOT_FOUND": "No account found with this email/login method.",
      "OMI_DATA_DOWNLOAD_APP_MSG_BODY": "Your data download request has been processed. For security reasons, please log in to your account page {url} to download.",
      "OMI_DATA_DOWNLOAD_APP_MSG_TITLE": "Your data download is ready",
      "OMI_DATA_DOWNLOAD_CANCEL_BTN": "Cancel",
      "OMI_DATA_DOWNLOAD_CANCEL_CONFIRM_BTN": "I understand, cancel",
      "OMI_DATA_DOWNLOAD_CANCEL_DESC": "If the file is ready, cancelling will delete it immediately. Ready files expire 7 days after they become available.",
      "OMI_DATA_DOWNLOAD_CANCEL_KEEP_BTN": "Keep request",
      "OMI_DATA_DOWNLOAD_CANCEL_POINT_1": "This request will be removed from the list after cancellation.",
      "OMI_DATA_DOWNLOAD_CANCEL_POINT_2": "You can always submit a new request later.",
      "OMI_DATA_DOWNLOAD_CANCEL_TITLE": "Cancel this request?",
      "OMI_DATA_DOWNLOAD_CODE_INCORRECT": "The code is incorrect or expired. Please try again.",
      "OMI_DATA_DOWNLOAD_CONTINUE_APPLE": "Continue with Apple",
      "OMI_DATA_DOWNLOAD_CONTINUE_FACEBOOK": "Continue with Facebook",
      "OMI_DATA_DOWNLOAD_CONTINUE_GOOGLE": "Continue with Google",
      "OMI_DATA_DOWNLOAD_DATA_AVAILABLE_UNTIL": "Data available until:",
      "OMI_DATA_DOWNLOAD_DATA_EXPIRED": "Your account data has exceeded the retention period and is no longer available for download.",
      "OMI_DATA_DOWNLOAD_DELETED_ON": "Account deleted on:",
      "OMI_DATA_DOWNLOAD_DONE_BTN": "Done",
      "OMI_DATA_DOWNLOAD_DOWNLOAD_BTN": "Download",
      "OMI_DATA_DOWNLOAD_DOWNLOAD_TITLE": "Download Your Data",
      "OMI_DATA_DOWNLOAD_DOWNLOAD_VERIFY_EMAIL": "For security, please enter your email address to confirm your identity before downloading.",
      "OMI_DATA_DOWNLOAD_DOWNLOAD_VERIFY_PHONE": "For security, please enter the last 4 digits of your phone number to confirm your identity before downloading.",
      "OMI_DATA_DOWNLOAD_EMAIL_BODY": "Your data download request has been processed and is now ready. Please log in to your account management page to download your data: {link}. This download will be available for 7 days (until {date}).",
      "OMI_DATA_DOWNLOAD_EMAIL_DATA_READY_BODY": "Your data download is ready. Click the link below to download: {link}. For security, you will need to verify your email address before downloading. Link valid for 24 hours.",
      "OMI_DATA_DOWNLOAD_EMAIL_DATA_READY_SUBJECT": "[{app_name}] Your Data is Ready to Download",
      "OMI_DATA_DOWNLOAD_EMAIL_INCORRECT": "The email address you entered does not match. Please try again.",
      "OMI_DATA_DOWNLOAD_EMAIL_INPUT_HINT": "Enter your email address to receive a verification code.",
      "OMI_DATA_DOWNLOAD_EMAIL_SUBJECT": "[{app_name}] Your Data Download is Ready",
      "OMI_DATA_DOWNLOAD_EMAIL_VERIFICATION_BODY": "Your verification code is: {code}. This code will expire in 10 minutes. If you didn't request this code, please ignore this email.",
      "OMI_DATA_DOWNLOAD_EMAIL_VERIFICATION_SUBJECT": "[{app_name}] Your verification code",
      "OMI_DATA_DOWNLOAD_HISTORY_DESC": "Each record covers the last 12 months prior to the request. Ready files are valid for 7 days.",
      "OMI_DATA_DOWNLOAD_HISTORY_TITLE": "Your Download Requests",
      "OMI_DATA_DOWNLOAD_LINK_EXPIRED_DESC": "This download link has expired or is no longer valid.",
      "OMI_DATA_DOWNLOAD_LINK_EXPIRED_TITLE": "Link Expired",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_APP": "You will receive a notification from {app_name} Team in the app once your data is ready.",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_EMAIL": "You will receive an email notification at {email} once your data is ready.",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_EMAIL_DESC": "You will receive an email notification at {email} once your data is ready.",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_SMS": "You will receive an SMS notification at {phone} once your data is ready.",
      "OMI_DATA_DOWNLOAD_NOTIFICATION_SMS_DESC": "You will receive an SMS notification at {phone} once your data is ready.",
      "OMI_DATA_DOWNLOAD_PAGE_SUBTITLE": "Requests & history",
      "OMI_DATA_DOWNLOAD_PAGE_TITLE": "Download My Information",
      "OMI_DATA_DOWNLOAD_PHONE_DIGITS_INCORRECT": "The digits you entered do not match. Please try again.",
      "OMI_DATA_DOWNLOAD_PHONE_INPUT_HINT": "Enter your phone number to receive a verification code.",
      "OMI_DATA_DOWNLOAD_REQUEST_NEW_DOWNLOAD": "Request New Download",
      "OMI_DATA_DOWNLOAD_REQUEST_SUBMITTED": "Request Submitted",
      "OMI_DATA_DOWNLOAD_REQUEST_SUBMITTED_DESC": "We will prepare a ZIP of your data within 24 hours, covering the last 12 months.",
      "OMI_DATA_DOWNLOAD_RESEND_CODE": "Resend code",
      "OMI_DATA_DOWNLOAD_RETRIEVE_ACTION_DESC": "To retrieve a copy of your data, submit a download request.",
      "OMI_DATA_DOWNLOAD_RETRIEVE_DESC": "You can download a copy of your personal data if your account is still active or was deleted within the past 3 months.",
      "OMI_DATA_DOWNLOAD_RETRIEVE_SUBTITLE": "Verify your identity to continue",
      "OMI_DATA_DOWNLOAD_RETRIEVE_TITLE": "Retrieve Your Data",
      "OMI_DATA_DOWNLOAD_SEND_CODE_BTN": "Send Verification Code",
      "OMI_DATA_DOWNLOAD_SMS_DATA_READY": "Your data is ready for download. Log in to download: {{link}}. Valid for 7 days.",
      "OMI_DATA_DOWNLOAD_SMS_DATA_READY_1DAY": "Your data is ready for download. Download here: {{link}}. This link expires in 24 hours.",
      "OMI_DATA_DOWNLOAD_SMS_VERIFICATION_CODE": "Your {app_name} verification code is: {code}. This code expires in 10 minutes. Do not share this code with anyone.",
      "OMI_DATA_DOWNLOAD_STATUS_PREPARING": "Preparing",
      "OMI_DATA_DOWNLOAD_STATUS_READY": "Ready",
      "OMI_DATA_DOWNLOAD_SUBMIT_BTN": "Submit Download Request",
      "OMI_DATA_DOWNLOAD_SUBMIT_DESC": "To export a copy of your data, submit a download request. We will prepare a ZIP of your data within 24 hours, covering the last 12 months.",
      "OMI_DATA_DOWNLOAD_SUBMIT_REQUEST_BTN": "Submit Data Request",
      "OMI_DATA_DOWNLOAD_SUBMIT_SECTION_TITLE": "Submit a Download Request",
      "OMI_DATA_DOWNLOAD_TEMP_PHONE_DESC": "Since your account doesn't have a phone number or email on file, please provide a phone number to receive your download notification.",
      "OMI_DATA_DOWNLOAD_TEMP_PHONE_NOTICE": "This number will only be used for this download request and will not be added to your account.",
      "OMI_DATA_DOWNLOAD_TEMP_PHONE_TITLE": "Provide Contact for Notification",
      "OMI_DATA_DOWNLOAD_TOO_MANY_ATTEMPTS": "Too many attempts. Please try again in 1 day.",
      "OMI_DATA_DOWNLOAD_USE_DIFFERENT_EMAIL": "Use a different email",
      "OMI_DATA_DOWNLOAD_USE_DIFFERENT_PHONE": "Use a different phone number",
      "OMI_DATA_DOWNLOAD_VALID_UNTIL": "Valid until:",
      "OMI_DATA_DOWNLOAD_VERIFY_BTN": "Verify",
      "OMI_DATA_DOWNLOAD_VERIFY_EMAIL_DESC": "We've sent a 6-digit code to {email}.",
      "OMI_DATA_DOWNLOAD_VERIFY_PHONE_DESC": "Enter the 6-digit code sent to {phone}.",
      "OMI_DATA_DOWNLOAD_VERIFY_PHONE_TITLE": "Verify Phone Number",
      "OMI_DATA_DOWNLOAD_VERIFY_WITH_EMAIL": "Verify with Email",
      "OMI_DATA_DOWNLOAD_VERIFY_WITH_PHONE": "Verify with Phone Number",
      "OMI_LANDINGPAGE_SIGNIN_APPLE_NEW": "Sign In With Apple",
      "OMI_LOGIN_SUBSCRIPTION": "By logging in, you agree to our policies and terms. Learn about our Cookie Policy and Privacy Policy.",
      "OMI_SETTING_COOKIE_POLICY": "Cookie policy"
    }
  },
  "th": {
    "translation": {}
  },
  "id": {
    "translation": {}
  },
  "ms": {
    "translation": {}
  }
};
export default i18nStore;